import http from "../../../utils/fetch";
export default {

    baseurl:'/api/swyl/v1/reform/bscSpecificGy',

    selecPage(query) {
        return http({
            url: this.baseurl+'/selectPage',
            method: 'post',
            params: query
        });
    },

    //新增
    save(query){
        return http({
            url: this.baseurl+'/insert',
            method: 'post',
            params: query
        });
    },

    //删除
    deleteById(id){
        return http({
            url: this.baseurl+'/deleteById',
            method: 'post',
            params: {id:id}
        });
    },
    //
    selectById(id){
        return http({
            url: this.baseurl+'/selectById',
            method: 'post',
            params: {id:id}
        });
    },

}
